import { connect } from 'react-redux'
import ProductListViewPullSellersProductsToOrder from './ProductListViewPullSellersProductsToOrder'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewPullSellersProductsToOrder)
